import { NgModule } from '@angular/core';
import { EntitlementsModule } from '@ddv/entitlements';
import { HttpModule } from '@ddv/http';
import { NamedQueriesModule } from '@ddv/named-queries';

import { ClientsService } from './clients.service';
import { FundsService } from './funds.service';
import { FuzzyDatesService } from './fuzzy-dates.service';

@NgModule({
    imports: [
        EntitlementsModule,
        HttpModule,
        NamedQueriesModule,
    ],
    providers: [
        ClientsService,
        FundsService,
        FuzzyDatesService,
    ],
})
export class ReferenceDataModule {}
